module.exports = __webpack_public_path__ + "img/tu3.08fdda35.png";